/**
 * This code handles interactivity for hotspots on the page.
 * It adds/removes the 'active' class on hotspots when hovering over
 * corresponding elements with matching data attributes.
 * There are also functions to briefly highlight elements when hotspots are
 * hovered over.
 */
(function () {
  // Add class on the hotspot when promo prod is equal - on hover
  const inspHotspots = document.querySelectorAll(".hotspot");
  const promoProdsContainer = document.querySelector(".hotspot-items");

  if (promoProdsContainer) {
    promoProdsContainer.addEventListener("mouseover", function (e) {
      const parentContainer = e.target.closest(".hotspot-item");
      inspHotspots.forEach((hotspot) => {
        hotspot.classList.remove("active");
        if (hotspot.getAttribute("data-value") == parentContainer.querySelector('[data-name="promo-anchor-prod-item"]').id) {
          hotspot.classList.add("active");
        }
      });
    });

    promoProdsContainer.addEventListener("mouseleave", function () {
      inspHotspots.forEach((hotspot) => {
        hotspot.classList.remove("active");
      });
    });
  }

  function focusIdItemShopTheLook(e) {
    let idItemValue = e.target.getAttribute("data-value");
    document.getElementById(idItemValue).parentElement.classList.add("active");
    setTimeout(() => {
      document.getElementById(idItemValue).parentElement.classList.remove("active");
    }, 1000);
  }

  document.querySelectorAll('[data-name="custom-hotspot"]').forEach((hotspot) => {
    hotspot.addEventListener("mouseover", focusIdItemShopTheLook);
  });
})();
